import { render, staticRenderFns } from "./ExamManagementConfirmation.vue?vue&type=template&id=5e5db0f6&scoped=true"
import script from "./ExamManagementConfirmation.vue?vue&type=script&lang=js"
export * from "./ExamManagementConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ExamManagementConfirmation.vue?vue&type=style&index=0&id=5e5db0f6&prod&lang=scss&scoped=true"
import style1 from "./ExamManagementConfirmation.vue?vue&type=style&index=1&id=5e5db0f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5db0f6",
  null
  
)

export default component.exports